export class AwsPrincipalInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "iamArn",
            "baseName": "iamArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsPrincipalInput.attributeTypeMap;
    }
    constructor() {
    }
}
